import * as React from 'react';

export const Google: React.SFC<{}> = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0)">
        <path
          d="M6.43242 14.0862L5.73625 16.6851L3.19176 16.7389C2.43133 15.3285 2 13.7148 2 11.9999C2 10.3417 2.40328 8.77795 3.11812 7.40103H3.11867L5.38398 7.81634L6.37633 10.0681C6.16863 10.6736 6.05543 11.3236 6.05543 11.9999C6.05551 12.734 6.18848 13.4373 6.43242 14.0862Z"
          fill="#F1BF42"
        />
        <path
          d="M21.8253 10.1318C21.9402 10.7368 22.0001 11.3615 22.0001 12C22.0001 12.7159 21.9248 13.4143 21.7814 14.0879C21.2946 16.3802 20.0226 18.3818 18.2605 19.7983L18.26 19.7978L15.4067 19.6522L15.0029 17.1313C16.1721 16.4456 17.0858 15.3725 17.5672 14.0879H12.2199V10.1318H17.6452H21.8253Z"
          fill="#5284EC"
        />
        <path
          d="M18.2598 19.7979L18.2604 19.7984C16.5467 21.1759 14.3697 22 12 22C8.19173 22 4.88075 19.8715 3.19173 16.7391L6.43239 14.0863C7.27688 16.3402 9.45106 17.9446 12 17.9446C13.0956 17.9446 14.122 17.6484 15.0027 17.1314L18.2598 19.7979Z"
          fill="#66AD6A"
        />
        <path
          d="M18.3829 4.30219L15.1434 6.95437C14.2319 6.38461 13.1544 6.05547 12 6.05547C9.39338 6.05547 7.17853 7.73348 6.37635 10.0681L3.11865 7.40109H3.1181C4.7824 4.1923 8.13513 2 12 2C14.4263 2 16.6511 2.8643 18.3829 4.30219Z"
          fill="#D85040"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="20" height="20" fill="white" transform="translate(2 2)" />
        </clipPath>
      </defs>
    </svg>
  );
};
